export default "/images/logocircular.png?355bc4ab648fdd903feeb685de352a7a";